import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t bg-card/50 mt-auto">
      <div className="container py-6 px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} TrainerPulse. All rights reserved.
          </p>
          <nav className="flex flex-wrap justify-center gap-4 text-sm">
            <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
              Privacy
            </Link>
            <Link to="/refund-policy" className="text-muted-foreground hover:text-primary transition-colors">
              Refunds
            </Link>
            <Link to="/cookies" className="text-muted-foreground hover:text-primary transition-colors">
              Cookies
            </Link>
            <Link to="/acceptable-use" className="text-muted-foreground hover:text-primary transition-colors">
              Acceptable Use
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
